// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

const deviseScope = document.querySelector('meta[name="devise-scope"]')?.content || '';
const cableUrl = new URL('/cable', window.location.origin);
if (deviseScope) {
  cableUrl.searchParams.set('scope', deviseScope);
}
const consumer = createConsumer(cableUrl.toString());

consumer.subscriptions.create_mod = function (argument, mixin){
  let channelName = argument;
  if (typeof(argument) === "object") {
    channelName = argument.channel;
  }
  return this.create({
    ...argument,
    ...{},
  }, mixin);
}

export default consumer;
